import { updateProfile } from 'firebase/auth';
import { ref as databaseRef, update } from 'firebase/database';
import { ref as storageRef, deleteObject } from 'firebase/storage';
import { database, storage } from '../../firebase';

export async function removePersonalPhoto(user, ownerCompanyId) {
  const previousPhoto = user.photoURL || null;
  await updateProfile(user, { photoURL: null });
  try {
    // Other employer screens read this copy for the organization's owner.
    if (ownerCompanyId) {
      await update(databaseRef(database, `companies/${ownerCompanyId}`), { ownerPhotoUrl: null });
    }
  } catch (error) {
    // Preserve the displayed photo if the shared owner record could not be saved.
    await updateProfile(user, { photoURL: previousPhoto });
    throw error;
  }

  try {
    // Delete only the signed-in user's managed upload, never an external photo URL.
    await deleteObject(storageRef(storage, `userProfiles/${user.uid}`));
  } catch (error) {
    if (error.code !== 'storage/object-not-found') {
      // The account no longer points to the image even if storage cleanup fails.
      console.warn('Profile photo removed; uploaded-file cleanup failed.', error.code);
    }
  }
}
